import { Checkbox } from "@/components/ui/Checkbox";
import type { CheckboxProps } from "@/components/ui/Checkbox";
import { twMerge } from "tailwind-merge";

type CheckboxBlockProps = Omit<CheckboxProps, "className">;

export function CheckboxBlock({ checked, ...props }: CheckboxBlockProps) {
  return (
    <div
      className={twMerge(
        "rounded-lg border px-4 py-3.5 transition-all duration-200",
        checked
          ? "border-action-wash bg-action-wash"
          : "border-surface-hover bg-brand-gray",
      )}
    >
      <Checkbox checked={checked} {...props} />
    </div>
  );
}
